module.exports = __webpack_public_path__ + "static/media/purepapermetal-skin-tin-mill-finish-723-panel.d98d281d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/purepapermetal-skin-tin-mill-finish-723-panel.jpg
// module id = 1128
// module chunks = 37